if (document.querySelector('.menu')) {
    document.querySelector('.menu').addEventListener('click', function (e) {
        e.preventDefault();

        if (document.querySelector('.front-nav')) {
            let nav = document.querySelector('.front-nav');

            nav.classList.toggle('mobile-hidden');
        }
    });
}

document.querySelectorAll('.dropdown').forEach(function (link) {
    link.addEventListener('click', function (e) {
        e.preventDefault();

        if (document.querySelector(`.dropdown-${this.dataset.dropdownMenu}`)) {
            let div = document.querySelector(`.dropdown-${this.dataset.dropdownMenu}`);
            div.classList.toggle('hidden');
        }
    })
});

document.querySelector('button.location').addEventListener('click', function (e) {
    e.preventDefault();

    if (this.classList.contains('location-active')) {
        // Deactivate
        this.classList.remove('location-active')

        document.querySelector('input[name="location"]').value = '';
    } else {
        this.classList.add('location-active');

        if (! navigator.geolocation) {
            alert("Geolocation is not supported by your browser");

            return;
        }

        function success(position) {
            let latitude = position.coords.latitude;
            let longitude = position.coords.longitude;

            document.querySelector('input[name="location"]').value = `${latitude}|${longitude}`;
        }

        function error() {
            document.querySelector('input[name="location"]').value = '';

            alert("Unable to retrieve your location");
        }


        navigator.geolocation.getCurrentPosition(success, error);
    }
});
